export default __webpack_public_path__ + "static/media/interestHome.cab615d7.svg";